'use strict';

var translations = {
    warnings: {
        straightRow: '避免连排的按键，比如“asdf”。',
        simpleRepeat: '避免重复的单词和字符，比如“aaa”和“abcabc”。',
        extendedRepeat: '避免重复的单词和字符，比如“aaa”和“abcabc”。',
        sequences: '避免序列，比如“abc”或“6543”。',
        recentYears: '避免最近的年份，比如“2020”。',
        dates: '避免日期。',
        topTen: '避免常用密码。',
        topHundred: '避免常用密码。',
        common: '避免常用密码。',
        similarToCommon: '避免常用密码。',
        wordByItself: '避免单独使用一个单词。',
        namesByThemselves: '避免单独使用姓氏和名字。',
        commonNames: '避免单独使用姓氏和名字。',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: '包含两个以上单词的长字符串；避免常用短语。',
        anotherWord: '添加一两个单词，不常见用词更好。',
        repeated: '避免重复的单词和字符，比如“aaa”和“abcabc”。',
        l33t: '避免容易预测的替代，比如用“@”代替“a”（如“@pple”代替“Apple”）。',
        reverseWords: '避免反向单词，比如“elppa”（“apple”的反向）。',
        allUppercase: '全大写和全小写几乎同样容易被猜到。',
        dates: '避免日期。',
        associatedYears: '避免日期。',
        recentYears: '避免最近的年份，比如“2020”。',
        sequences: '避免序列，比如“abc”或“6543”。',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
